import { useState } from "react";
import Menu from '../menu/Menu';
import PrivacyPolicyPrivate from "./PrivacyPolicyPrivate";



export default function PrivacyPolicyScreen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <PrivacyPolicyPrivate onOpenMenu={() => setIsMenuOpen(true)} />
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white">
          <Menu isLoggedIn={true} onClose={() => setIsMenuOpen(false)} />
        </div>
      )}
    </>
  );
}
